<template>
	<v-container fluid class="pa-0">
		<v-row class="grid-toolbar" no-gutters>
			<v-col class="flex-grow-1 flex-shrink-1">
				<quick-filter
					:Columns="gridViewFields"
					:filter="quickFilter"
					@filterChanged="onQuickFilterChanged"
				/>
			</v-col>

			<v-col class="flex-grow-0 flex-shrink-0 d-none d-lg-flex align-end">
				<v-btn color="primary" @click="onShowAdvancedFilter">
					<v-icon class="mr-1">mdi-magnify</v-icon>
					Advanced search
				</v-btn>
			</v-col>

			<v-col class="flex-grow-0 flex-shrink-0 d-none d-lg-flex align-end">
				<!-- Desktop Export Modal (≥lg) -->
				<export-modal
					:timezone-options="false"
					:execution-options="false"
					:data-scope-options="true"
					:additional-options="activityExportOptions"
					@exportModalEvent="onExportModalEvent"
				>
					<template #activator="{ on, attrs }">
						<v-btn
							v-bind="attrs"
							v-on="on"
							color="primary"
							class="ml-2"
						>
							<v-icon class="mr-1">mdi-cloud-download</v-icon>
							Export
						</v-btn>
					</template>
				</export-modal>
			</v-col>

			<v-col class="flex-grow-0 flex-shrink-0 d-flex d-lg-none align-end">
				<!-- Mobile/Tablet Dots Menu (<lg) -->
				<v-menu
					v-model="dotsMenuOpen"
					offset-y
					:close-on-content-click="false"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							v-bind="attrs"
							v-on="on"
							color="primary"
							class="d-lg-none"
						>
							<v-icon>mdi-dots-vertical</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item @click="onAdvancedSearchFromDots">
							<v-list-item-content>
								<v-list-item-title>
									<v-icon small left>mdi-magnify</v-icon>
									Advanced search
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<export-modal
							:timezone-options="false"
							:execution-options="false"
							:data-scope-options="true"
							:additional-options="activityExportOptions"
							@exportModalEvent="onExportModalEventFromDots"
						>
							<template #activator="{ on, attrs }">
								<v-list-item v-bind="attrs" v-on="on">
									<v-list-item-content>
										<v-list-item-title>
											<v-icon small left
												>mdi-cloud-download</v-icon
											>
											Export
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</template>
						</export-modal>
					</v-list>
				</v-menu>
			</v-col>
		</v-row>
		<filters-dialog
			v-if="showAdvancedFilter"
			:dialog="showAdvancedFilter"
			:filter="advancedFilter"
			:columns="gridViewFields"
			@filterChanged="onAdvancedFilterChanged"
		/>
	</v-container>
</template>
<script>
import QuickFilter from '../shared/gridViews/QuickFilter.vue';
import FiltersDialog from '../shared/gridViews/FiltersDialog';
import ExportModal from '../shared/export/ExportModal.vue';
import { ActivityGetters } from '../../store/getters';
import { ActivityActions } from '../../store/actions';
import { mapGetters } from 'vuex';
import { ExportMode } from '../../enums/ExportMode';
export default {
	name: 'ActivityToolbar',
	data() {
		return {
			showAdvancedFilter: false,
			dotsMenuOpen: false,
		};
	},
	props: {
		quickFilter: Object,
		advancedFilter: Object,
		disableDetailedExport: Boolean,
	},
	components: {
		QuickFilter,
		FiltersDialog,
		ExportModal,
	},
	computed: {
		...mapGetters({
			gridViewFields: [ActivityGetters.GRID_VIEW_FIELDS],
		}),
		activityExportOptions() {
			return [
				{
					key: 'exportRecords',
					label: 'Export records',
					disabled: this.disableDetailedExport,
				},
			];
		},
	},
	methods: {
		onExportModalEvent(exportConfig) {
			const isDirectMode = !exportConfig.isBackgroundExport;
			if (exportConfig.additionalOption === 'exportRecords') {
				this.exportRecords();
			} else if (exportConfig.allData) {
				this.exportAllData(isDirectMode);
			} else {
				this.exportVisibleData(isDirectMode);
			}
		},
		onAdvancedSearchFromDots() {
			this.dotsMenuOpen = false;
			this.showAdvancedFilter = true;
		},
		onExportModalEventFromDots(exportConfig) {
			this.dotsMenuOpen = false;
			this.onExportModalEvent(exportConfig);
		},
		onQuickFilterChanged(value) {
			this.$emit('quickFilterChanged', value);
		},
		onShowAdvancedFilter() {
			this.showAdvancedFilter = true;
		},
		onAdvancedFilterChanged(value) {
			this.$emit('advancedFilterChanged', value);
			this.showAdvancedFilter = false;
		},
		exportVisibleData(isDirectMode = ExportMode.DIRECT) {
			this.$store.dispatch(ActivityActions.EXPORT_ACTIVITY_VISIBLE_DATA, {
				id: this.$route.params.activityId,
				isDirectMode: isDirectMode,
			});
		},
		exportAllData(isDirectMode = ExportMode.DIRECT) {
			this.$store.dispatch(ActivityActions.EXPORT_ACTIVITY_ALL_DATA, {
				id: this.$route.params.activityId,
				isDirectMode: isDirectMode,
			});
		},
		exportRecords() {
			this.$emit('exportRecords');
		},
	},
};
</script>
